import {
  useSearchQueryFilter,
  useSearchSimilarityFromRoute,
  useSearchTypeFromRoute,
} from '@aibees/elephant/hooks';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchDataMaxPageExceeded } from '../search-data-max-page-exceeded';
import { getConfig } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import { type SearchDataNotFoundProps as Props } from './types';

export const SearchDataNotFound = memo(({ className }: Props) => {
  const type = useSearchTypeFromRoute();
  const isSimilarity = useSearchSimilarityFromRoute();
  const { getParam, removeAllParams } = useSearchQueryFilter();
  const pageNumber = +(getParam('page') || 0);
  const navigate = useNavigate();
  const config = getConfig(isSimilarity);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleClearFilters = () => {
    removeAllParams();
  };

  if (pageNumber >= 100) return <SearchDataMaxPageExceeded />;

  if (!type) return null;

  return (
    <Styled.Wrapper
      className={classnames('SearchDataNotFound', className)}
      sx={SX.root(config[type].src)}
    >
      <Stack gap={2}>
        <Typography variant="h5" fontWeight={600} color="grey.700">
          {config[type].title}
        </Typography>

        <Typography variant="body1" fontWeight={400} color="grey.500">
          {config[type].description}
        </Typography>
      </Stack>

      <Stack gap={2} direction="row" justifyContent="space-between">
        <Button
          variant="outlined"
          startIcon={<Icon name="chevron-left" size={16} />}
          onClick={handleGoBack}
          size="medium"
          color="default"
        >
          {config[type].buttonText}
        </Button>
        <Button
          variant="outlined"
          onClick={handleClearFilters}
          size="medium"
          color="error"
        >
          Clear Filters
        </Button>
      </Stack>
    </Styled.Wrapper>
  );
});

SearchDataNotFound.displayName = 'SearchDataNotFound';
